import { render, staticRenderFns } from "./v-textarea.vue?vue&type=template&id=674fb21a&scoped=true&"
import script from "./v-textarea.vue?vue&type=script&lang=js&"
export * from "./v-textarea.vue?vue&type=script&lang=js&"
import style0 from "./v-textarea.vue?vue&type=style&index=0&id=674fb21a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674fb21a",
  null
  
)

export default component.exports